import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { Footer } from "@/components/Footer";
import { useSeo } from "@/lib/useSeo";
import { ArrowLeft } from "lucide-react";

export default function Privacy() {
  useSeo({
    title: "Privacy Policy — SuiteCrowd",
    description:
      "Informativa sulla privacy di SuiteCrowd: trattamento dati personali, cookie, diritti dell'utente ai sensi del GDPR (Regolamento UE 2016/679).",
    canonical: "https://suitecrowd.com/privacy",
  });

  return (
    <div className="min-h-screen bg-white text-[#121212]">
      <nav className="border-b border-[#E5E5E5] bg-white/80 backdrop-blur-md sticky top-0 z-30">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex justify-between items-center">
          <Logo variant="dark" size="md" />
          <Link to="/" className="text-[11px] tracking-[0.24em] uppercase text-neutral-500 hover:text-[#121212] inline-flex items-center gap-2 transition-colors">
            <ArrowLeft size={14} /> Home
          </Link>
        </div>
      </nav>

      <article className="max-w-3xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <div className="sc-overline mb-6">Informativa</div>
        <h1 className="font-display font-light text-4xl md:text-5xl mb-4" style={{ letterSpacing: "-0.03em" }}>
          Privacy Policy
        </h1>
        <p className="text-sm text-neutral-500 mb-16">
          Ai sensi del Regolamento UE 2016/679 (GDPR)
        </p>

        <div className="space-y-14 text-[15px] leading-[1.85] text-neutral-700">
          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Titolare del trattamento</h2>
            <p>
              Il titolare del trattamento dei dati è SuiteCrowd, contattabile
              all'indirizzo{" "}
              <a href="mailto:privacy@suitecrowd.com" className="underline decoration-neutral-400 hover:text-[#0B192C]">
                privacy@suitecrowd.com
              </a>
              .
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Dati raccolti</h2>
            <ul className="list-disc pl-5 space-y-2">
              <li><strong>Waitlist:</strong> email, codice referral, posizione, data di iscrizione.</li>
              <li><strong>Pagamenti:</strong> nessun dato di carta viene conservato da SuiteCrowd. Il pagamento è gestito da Stripe (PCI-DSS Level 1) attraverso un conto escrow.</li>
              <li><strong>Analytics:</strong> dati di navigazione anonimizzati (nessuna profilazione pubblicitaria).</li>
            </ul>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Finalità</h2>
            <p>
              I dati sono trattati esclusivamente per: gestione della waitlist e del
              programma referral, invio di comunicazioni transazionali relative al
              tuo account e ai progetti sostenuti, adempimenti fiscali e contabili.
              Non cediamo mai i tuoi dati a terzi per finalità di marketing.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Conservazione</h2>
            <p>
              I dati sono conservati per il tempo strettamente necessario alle
              finalità sopra indicate e comunque non oltre 10 anni dall'ultima
              interazione, salvo obblighi di legge di conservazione più estesa.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Cookie</h2>
            <p>
              Utilizziamo esclusivamente cookie tecnici necessari al funzionamento
              del sito e strumenti di analisi anonimizzata. Nessun cookie di
              profilazione pubblicitaria. Puoi gestire le preferenze in qualsiasi
              momento cancellando i dati del sito dal tuo browser.
            </p>
          </section>

          <section>
            <h2 className="font-display text-xl font-normal text-[#121212] mb-4">Diritti dell'interessato</h2>
            <p>
              In qualunque momento puoi esercitare i diritti di accesso, rettifica,
              cancellazione, limitazione, portabilità e opposizione al trattamento
              scrivendo a{" "}
              <a href="mailto:privacy@suitecrowd.com" className="underline decoration-neutral-400 hover:text-[#0B192C]">
                privacy@suitecrowd.com
              </a>
              . Hai inoltre il diritto di proporre reclamo all'autorità di controllo
              (Garante per la Protezione dei Dati Personali).
            </p>
          </section>
        </div>
      </article>

      <Footer />
    </div>
  );
}
